export interface ToastItem {
  id: string;
  variant: 'success' | 'error';
  message: string;
}

type Listener = (toasts: ToastItem[]) => void;

let toasts: ToastItem[] = [];
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((listener) => listener(toasts));
}

function dismiss(id: string) {
  toasts = toasts.filter((item) => item.id !== id);
  emit();
}

function push(variant: ToastItem['variant'], message: string) {
  const id = crypto.randomUUID();
  toasts = [...toasts, { id, variant, message }];
  emit();
}

/**
 * App-wide toast queue (mnr-standards: one generic primitive per shared
 * need). Feature code calls `toast.success`/`toast.error` - it never touches
 * the queue or renders `Toast` directly. `Toaster` (components/common)
 * subscribes via `useToastQueue` and is mounted once in App.tsx.
 */
export const toast = {
  success: (message: string) => push('success', message),
  error: (message: string) => push('error', message),
  dismiss,
};

/** Internal: `useToastQueue` is the supported way to read the live queue. */
export function subscribeToToasts(listener: Listener): () => void {
  listeners.add(listener);
  listener(toasts);
  return () => {
    listeners.delete(listener);
  };
}
